<template>
  <v-card :width="$isMobile ? (windowInnerWidth * 0.98) - 20 : 734"
          :style="$isMobile ? 'background: #F8F5FD;border: none':''">
    <div v-if="$isMobile">
      <div class="pa-2 rounded">
        <v-img
          :src="require('chinese' === language ? '@/assets/images/itsm-banner.png' : '@/assets/images/incident-ticket-banner.png')"></v-img>
      </div>
      <div class="d-flex justify-center align-center flex-column mx-4 mt-n2 mb-4 rounded-lg rounded-t-0" style="background: white">
        <img style="width: 100px" class="mt-4" :src="require('@/assets/images/icon-create-success.png')">
        <div class="mt-1 font-weight-bold" style="color: #342D39;font-size: 18px;">{{ language === 'chinese' ? '创建成功' : 'Submission successful'}}</div>
        <v-chip class="ml-2 my-4" style="background:#F8F8F8; font-size: 18px; font-weight: 500;">
          <span style="color:#B0A6BD;">NO: {{ ticketNumber }}</span>
        </v-chip>
      </div>
    </div>
    <div v-else>
      <v-card-title>
        <v-img max-width="48" max-height="48" :src="require('@/assets/images/icon-成功.png')"></v-img>
        <span
          style="color: #A200FF">{{ language === 'chinese' ? '工单创建成功通知！' : 'Submission successful !'
          }}</span>
      </v-card-title>
      <v-card-text>
        <span class="ml-2" style="font-size: 18px; font-weight: 500;">NO: {{ ticketNumber }}</span>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    language: {
      type: String,
      default: 'chinese',
    },
    title: {
      type: String,
      default: '工单创建成功通知',
    },
    ticketNumber: {
      type: String,
      default: '',
    },
    ticketLink: {
      type: String,
      default: '',
    },
  },
  computed: {
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data() {
    return {}
  },
  mounted() {
  },
}
</script>
